import { AccountCircle, AccountTree, Contacts, DoubleArrow, Explore, Home } from '@mui/icons-material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import School from '@mui/icons-material/School';
import SettingsIcon from '@mui/icons-material/Settings';
import React from 'react';
import colors from '@/styles/colors';

const iconBG = 'rgba(17, 24, 39)';

export const GLOBAL_CONSTANTS = {
  REGEX: {
    EMAIL:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
    FULLNAME: /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/i,
  },
  API_URLS: {
    userInfo: '/user',
    repos: '/repos',
    skills: '/skills',
    sendMail: '/sendMail',
    experience: '/experience',
    academicDetails: '/academic-details',
  },
  NAV_ITEMS: [
    { id: 'home', label: 'Home', icon: <Home htmlColor={colors.lighter} /> },
    { id: 'about', label: 'About', icon: <AccountCircle htmlColor={colors.lighter} /> },
    { id: 'projects', label: 'Projects', icon: <AccountTree htmlColor={colors.lighter} /> },
    { id: 'experience', label: 'Experience', icon: <Explore htmlColor={colors.lighter} /> },
    { id: 'skills', label: 'Skills', icon: <DoubleArrow htmlColor={colors.lighter} /> },
    { id: 'academic', label: 'Academic', icon: <School htmlColor={colors.lighter} /> },
    { id: 'contact', label: 'Contact Me', icon: <Contacts htmlColor={colors.lighter} /> },
  ],

  externalLinks: {
    github: 'https://github.com/papuruth',
    fb: 'https://facebook.com/papu.kc.1996',
    instagram: 'https://instagram.com/papuruth',
    linkedin: 'https://linkedin.com/in/papuruth',
    codersRank: 'https://profile.codersrank.io/user/papuruth/',
    linktree: 'https://linktr.ee/papuruth',
    resume: 'https://drive.google.com/file/d/1REGptoojZ4d7IaZX47YjvjQuA755qGm6/view?usp=sharing',
    emailTo: 'mailto:papuruth@gmail.com',
    phone: 'tel:+918392969958',
    reactJS: 'https://reactjs.org',
  },
  personalData: {
    mobile: '+918392969958',
    email: 'papuruth@gmail.com',
    aboutMe:
      "Software Frontend Engineer at Birdeye who's familiar with a wide range of programming utilities and languages like MERN Stack, JavaScript, TypeScript, Redux, PWA, GIT and JIRA. Knowledgeable in frontend development requirements with strong data structure concepts. Able to handle any part of the process with ease. Collaborative team player with excellent technical abilities offering #exp years of related experience.",
    DOBY: 1996,
  },
  academicTimelines: {
    icons: { localLibrary: <LocalLibraryIcon />, school: <School />, settings: <SettingsIcon />, accountBalance: <AccountBalanceIcon /> },
    iconStyle: { background: iconBG, color: colors.lighter },
  },
  EMP_START_DATE: '02/04/2019',
  GIT_START_DATE: '01/01/2015',
  MONTH_MAPPING: {
    January: 0,
    February: 1,
    March: 2,
    April: 3,
    May: 4,
    June: 5,
    July: 6,
    August: 7,
    September: 8,
    October: 9,
    November: 10,
    December: 11,
  },
};
